import { forwardRef, type Ref, type SVGProps } from "react";
const IconStreetViewFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M12 18h1.11l.78 7A1.15 1.15 0 0 0 15 26h2a1.15 1.15 0 0 0 1.11-1l.78-7H20a1.5 1.5 0 0 0 1.53-1.94L20 10a3 3 0 0 0-2.2-2.25h-.51a3 3 0 1 0-2.58 0h-.51A3 3 0 0 0 12 10l-1.53 6.06A1.5 1.5 0 0 0 12 18" />
    <path d="m21.42 22.31-.22 2A18.3 18.3 0 0 1 27.66 26c-1.35.83-5.39 2-11.66 2S5.69 26.83 4.34 26a18.3 18.3 0 0 1 6.46-1.71l-.22-2C5.54 22.92 2 24.34 2 26c0 2.21 6.27 4 14 4s14-1.79 14-4c0-1.66-3.54-3.08-8.58-3.69" />
  </svg>
);
const ForwardRef = forwardRef(IconStreetViewFilledSVG);
ForwardRef.displayName = "IconStreetViewFilled";
export { ForwardRef as IconStreetViewFilled };
